import { Documento } from './documento.model';

export class ProcessoDocumentoPendente {

  Id: number;
  Data: string;
  UsuarioId: number;
  UsuarioNome: string;
  Descricao: string;
  ProcessoId: number;
  DocumentoId: string;
  QtdCopias: number;
  Observacao: string;
  Recebido: boolean;
  DataRecebido: string;
  Entregue: boolean;
  DataEntregue: string;
  Documento: Documento;
  Ativo: boolean;

  constructor() {
    this.Id = 0,
      this.Documento = new Documento;
    this.QtdCopias = 1;
  }
}
